(ns frontend.view.grid.fof-assets-grid.columns
  (:require [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:asset/name
   :asset/description
   :asset/country
   :fof-asset/cur-size
   :fof-asset/tag-tags])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:asset/name})
